/** @format */
import { Heading } from '@mpb-com/feather/components/atoms/heading';
import { HeadingSize } from '@mpb-com/feather/components/atoms/heading/types';
import { useTranslation } from 'next-i18next';
import React, { FunctionComponent, useContext, useState } from 'react';
import styled from 'styled-components';

import OpenInNewTabIcon from '@toucan/client/global/icons/open-in-new-tab.svg';

import { MarketContext } from '@toucan/client/global/market';

import { Link, LinkTarget } from '@toucan/client/shared/components/link';

import { ProductComparisonItem } from '@toucan/client/features/model/components/model-overview/hooks/use-product-comparison/components/product-comparison-item';

import { SCROLL_LOCK_CONTENT_ID } from '@toucan/pages/_app';

import { DEFAULT_ROW_COUNT, DEFAULT_TEST_ID } from './constants';
import { styles } from './product-comparison-display.styles';
import {
    ProductComparisonDisplayProps,
    StyledProductComparisonDisplayProps,
} from './types';

const StyledProductComparisonDisplay = styled.div<StyledProductComparisonDisplayProps>`
    ${styles}
`;

export const ProductComparisonDisplay: FunctionComponent<
    ProductComparisonDisplayProps
> = ({
    'data-testid': dataTestId = DEFAULT_TEST_ID,
    productIds,
    currentProduct,
    ...otherProps
}) => {
    const { t } = useTranslation();
    const { activeMarket } = useContext(MarketContext);
    const [rowCount, setRowCount] = useState(DEFAULT_ROW_COUNT);
    const { urlSegment } = currentProduct;

    return (
        <StyledProductComparisonDisplay
            {...otherProps}
            data-testid={dataTestId}
            $productIds={productIds}
        >
            <Heading
                className="product-comparison-display-heading"
                size={HeadingSize.H3}
            >
                {t('Compare Products')}
            </Heading>

            <Link
                className="product-comparison-display-link"
                href={`/${activeMarket.slug}/${t('product', {
                    ns: 'urls',
                })}/${urlSegment}`}
                target={LinkTarget.BLANK}
                suffix={<OpenInNewTabIcon />}
            >
                {t('View all available {{modelName}}', {
                    modelName: currentProduct.name,
                })}
            </Link>
            <div
                id={SCROLL_LOCK_CONTENT_ID}
                className="product-comparison-display-scrollable-container"
            >
                <div className="product-comparison-display-list">
                    {productIds.map((productId, index) => (
                        <ProductComparisonItem
                            key={productId}
                            data-testid={`${dataTestId}-item-${index}`}
                            columnIndex={index}
                            productId={productId}
                            modelUrlSegment={urlSegment}
                            rowCount={rowCount}
                            setRowCount={setRowCount}
                        />
                    ))}
                </div>
            </div>
        </StyledProductComparisonDisplay>
    );
};
